import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './BreakingLive.css';
import breakingliveimage from '../../assets/pageimages/BreakingLive.webp';

function BreakingLiveHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>BreakingLive</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/breakinglive-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="breakinglive-bottomlink-style" />Live</Link></div>
              <div className="bottom-buttons-box"><Link to="/breakinglive-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="breakinglive-bottomlink-style" />My Flagged</Link></div>
              <div className="bottom-buttons-box"><Link to="/breakinglive-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="breakinglive-bottomlink-style" />Analysed</Link></div>
              <div className="bottom-buttons-box"><Link to="/breakinglive-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="breakinglive-bottomlink-style" />POVified</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="breakinglive-id" src={breakingliveimage} alt="BreakingLive Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default BreakingLiveHome;
